export default {
    dataset: {
        data: [],
        total: 0,
    },
    isFetching: false,
    sort: [],
    page: 0,
    pageSize: 50,
};
